import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import SweetAlert from "react-bootstrap-sweetalert";
import { defaultDiacriticsRemovalMap } from "../../helpers/ascii_helper";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import filterFactory from "react-bootstrap-table2-filter";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  Alert,
  Label,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import PageLoader from "../../components/Loaders/pageLoader";
import BtnLoader from "../../components/Loaders/btnLoader";
import { Package, PackageOpen, Download } from "lucide-react";
import XLSX from "xlsx";
import { showToast } from "../../components/Toast";
//PDF
import {
  getTransfersMoscow,
  getFilteredTransfersMoscow,
  getTransfersMoscowList,
  addTransferMoscow,
  updateTransferMoscow,
  deleteTransferMoscow,
} from "../../store/transfers/actions";
// import { getScreenHeight } from '../../helpers/screen_height_helper';
//Import Breadcrumb
import MyExportCSV from "../../components/exportCSV";
import Breadcrumbs from "../../components/Breadcrumb";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Search } from "react-bootstrap-table2-toolkit";
import MultiSelect from "../../components/Filter/NomenclatureSearch";

class TransferMoscowList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transfers_moscow: [],
      transfers_moscow_nom: [],
      transfers_moscow_inv: [],
      transfers_moscow_ser: [],
      filtered_transfers_moscow: [],
      my_filtered_transfer_msc: [],
      displayHidden: false,
      selectedRows: [],
      selectedData: [],
      selectedFileData: [],
      shiftKeyPressed: false,
      selectedValues: {
        nomenclatureCode: [],
        invoiceNo: [],
        serialNo: [],
      },
      TransferMoscowListColumns: [
        //   {
        //     text: 'Date Added',
        //     dataField: 'createdAt',
        //     sort: true,
        //     csvExport: true,
        //     hidden: false,
        //     editable: false,
        //     csvFormatter: (cell, row, rowIndex) => row.date != null && new Date(row.date).toLocaleDateString('en-GB'),
        //     formatter: (cell, actShipping) => {
        //       let dateObj = actShipping.date;
        //       if (typeof cell !== 'object') {
        //         dateObj = new Date(cell);
        //       }
        //       return dateObj && `${('0' + dateObj.getDate()).slice(-2)}/${('0' + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()} ${dateObj.getHours()}:${dateObj.getMinutes()}`;
        //     },
        //     editor: {
        //       type: Type.DATE
        //     }
        //   },
        {
          text: "ID",
          dataField: "_id",
          sort: true,
          editable: false,
          csvExport: false,
          formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
          text: "Nomenclature Code",
          dataField: "nomenclatureCode",
          sort: true,
          editable: true,
          formatter: (cellContent, transfers_moscow) => (
            <h5 className="font-size-16 mb-1 text-center">
              {transfers_moscow.nomenclatureCode}
            </h5>
          ),
        },
        {
          text: "SerialNo",
          dataField: "serialNo",
          sort: true,
          editable: true,
          formatter: (cellContent, transfers_moscow) => (
            <h5 className="font-size-16 mb-1 text-center">
              {transfers_moscow.serialNo}
            </h5>
          ),
        },
        {
          text: "Product Name",
          dataField: "productName",
          sort: true,
          editable: false,
          formatter: (cellContent, transfers_moscow) => (
            <h5 className="font-size-16 mb-1 text-center">
              {transfers_moscow.productName}
            </h5>
          ),
        },
        {
          text: "Quantity",
          dataField: "quantity",
          sort: true,
          editable: true,
          formatter: (cellContent, transfers_moscow) => (
            <h5 className="font-size-16 mb-1 text-center">
              {transfers_moscow.quantity}
            </h5>
          ),
        },
        {
          text: "Quantity Left",
          dataField: "quantityLeft",
          sort: true,
          editable: true,
          formatter: (cellContent, transfers_moscow) => (
            <h5 className="font-size-16 mb-1 text-center">
              {transfers_moscow.quantityLeft}
            </h5>
          ),
        },
        {
          text: "Invoice",
          dataField: "invoiceNo",
          sort: true,
          editable: false,
          csvText: "Invoice Number",
          formatter: (cellContent, transfers_moscow) => (
            <h5 className="font-size-16 mb-1 text-center">
              {transfers_moscow.invoiceNo}
            </h5>
          ),
        },
        {
          text: "Box No",
          dataField: "boxNo",
          sort: true,
          editable: false,
          formatter: (cellContent, transfers_moscow) => (
            <h5 className="font-size-16 mb-1">{transfers_moscow.boxNo}</h5>
          ),
        },

        {
          dataField: "menu",
          //   isDummyField: true,
          text: "Action",
          editable: false,
          csvExport: false,
          formatter: (cellContent, transfers_moscow) => (
            <div className="d-flex gap-3">
              <>
                <Link className="text-danger" to="#">
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                    onClick={() => this.handleDelete(transfers_moscow)}
                  ></i>
                </Link>
              </>
            </div>
          ),
        },
      ],
    };
    this.getScreenHeight = this.getScreenHeight.bind(this);
    this.removeDiacritics = this.removeDiacritics.bind(this);
    this.handleExcelImportSubmit = this.handleExcelImportSubmit.bind(this);
    this.handleExcelImportChange = this.handleExcelImportChange.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.handleFilterDataSubmit = this.handleFilterDataSubmit.bind(this);
    this.handleFormReset = this.handleFormReset.bind(this);
    this.rowClasses = this.rowClasses.bind(this);
    this.hiddenRowKeys = this.hiddenRowKeys.bind(this);
    this.toggleHiddenOrders = this.toggleHiddenOrders.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleGlobalActionSubmit = this.handleGlobalActionSubmit.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);

    this.handleDelete = this.handleDelete.bind(this);
    this.deleteAlert = this.deleteAlert.bind(this);

    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.resetSelections = this.resetSelections.bind(this);
    this.getTotalSum = this.getTotalSum.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }
  componentDidMount() {
    const { onGetTransferMoscowList } = this.props;
    onGetTransferMoscowList();

    window.addEventListener("load", this.getScreenHeight);
    window.addEventListener("click", this.getScreenHeight, { once: true });
    window.addEventListener("resize", this.getScreenHeight);

    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  }
  componentWillUnmount() {
    window.removeEventListener("load", this.getScreenHeight);
    window.removeEventListener("click", this.getScreenHeight);
    window.removeEventListener("resize", this.getScreenHeight);

    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.filtered_transfers_moscow !==
      this.props.filtered_transfers_moscow
    ) {
      this.setState({
        filtered_transfers_moscow: this.props.filtered_transfers_moscow,
      });
    }
  }

  getScreenHeight = () => {
    if (document.getElementById("card-section") != null) {
      let screenHeight = document.getElementById("card-section").offsetHeight;
      document
        .querySelector(".react-bootstrap-table")
        .setAttribute(
          "style",
          "height: calc(" + screenHeight + "px - 100px); overflow: auto;"
        );
    }
  };

  afterSaveCell = (oldValue, newValue, row, column, rowId) => {
    const { onUpdateTransferMoscow } = this.props;
    setTimeout(() => {
      row[column.dataField] = newValue;

      onUpdateTransferMoscow(row);

      const result = this.state.TransferMoscowListColumns.map((row_map) => {
        if (row_map.id === rowId) {
          const newRow = { ...row_map };
          newRow[column.dataField] = newValue;
          return newRow;
        }
        return row_map;
      });
      this.setState({ TransferMoscowListColumns: result });
      // }
    }, 100);
    return { newValue, async: true };
  };

  handleSelectChange = (id, selectedOptions) => {
    this.setState((prevState) => ({
      selectedValues: { ...prevState.selectedValues, [id]: selectedOptions },
    }));
  };

  handleButtonClick = () => {
    const { onGetFilteredTransfersMoscow } = this.props;
    const { selectedValues } = this.state;

    onGetFilteredTransfersMoscow(selectedValues);

    this.setState({
      selectedRows: [],
    });
  };

  resetSelections = () => {
    this.setState({
      selectedValues: {
        nomenclatureCode: [],
        invoiceNo: [],
        serialNo: [],
      },
    });
  };

  rowClasses = (row, rowIndex) => {
    let classes = null;
    if (row.quantityLeft === 0) {
      classes = "on-hold-row";
    }
    return classes;
  };

  handleKeyDown(event) {
    if (event.shiftKey) {
      // Update the state when the shift key is pressed
      this.setState({ shiftKeyPressed: true });
    }
  }

  // Event handler for keyup event
  handleKeyUp(event) {
    if (!event.shiftKey) {
      // Update the state when the shift key is released
      this.setState({ shiftKeyPressed: false });
    }
  }

  removeDiacritics = (str) => {
    let changes = "";
    if (!changes) {
      changes = defaultDiacriticsRemovalMap;
    }
    for (var i = 0; i < changes.length; i++) {
      str = str.replace(changes[i].letters, changes[i].base);
    }
    return str;
  };

  toggleHiddenOrders = () => {
    this.setState((prevState) => ({ displayHidden: !prevState.displayHidden }));
  };

  handleDelete = (transfers_moscow) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText="Yes, delete it!"
        confirmBtnBsStyle="danger"
        title="Are you sure?"
        onConfirm={() => this.deleteAlert(transfers_moscow._id)}
        onCancel={this.hideAlert}
        focusCancelBtn
      ></SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });
  };

  deleteAlert = (id) => {
    const { onDeleteTransferMoscow } = this.props;
    onDeleteTransferMoscow(id);
    this.hideAlert();
  };

  handleGlobalActionSubmit = (e, values) => {
    const { onDeleteTransferMoscow, onUpdateTransferMoscow } = this.props;
    const { selectedRows } = this.state;
    const currentList = this.props.filtered_transfers_moscow;

    if (values.action === "delete") {
      const setStatusArr = [...selectedRows];
      console.log(setStatusArr);

      setStatusArr.map((id) => {
        onDeleteTransferMoscow(id);
      });
      this.setState({ transfers_moscow: "", selectedRows: [] });
      return;
    }

    if (values.action === "write_off") {
      // Optimistically update the local list
      console.log("selectedRows", selectedRows);
      const optimisticList = currentList.map((row) => {
        if (selectedRows.includes(row._id)) {
          const updatedRow = { ...row, quantityLeft: 0 };
          onUpdateTransferMoscow(updatedRow); // Trigger the actual update
          return updatedRow;
        }
        return row;
      });
      console.log("optimisticList", optimisticList);
      this.setState({
        filtered_transfers_moscow: optimisticList,
        selectedRows: [],
      });
    }
  };

  hideAlert = () => this.setState({ alert: null });

  handleExcelImportSubmit = (e, values) => {
    const { onAddTransferMoscow } = this.props;
    let importArr = [];
    for (let i = 0; i < this.state.selectedFileData.length; i++) {
      // importArr.push({
      //   netWeightEms: this.state.selectedFileData[i][0],
      //   priceAmountEms: this.state.selectedFileData[i][1],
      //   country: 'Germany'
      // });
      importArr.push(
        {
          nomenclatureCode: this.state.selectedFileData[i][0],
          serialNo: this.state.selectedFileData[i][1],
          productName: this.state.selectedFileData[i][2],
          quantity: this.state.selectedFileData[i][3],
          quantityLeft: this.state.selectedFileData[i][4],
          invoiceNo: this.state.selectedFileData[i][5],
          boxNo: this.state.selectedFileData[i][6],
        }
        // {
        //   country: this.state.selectedFileData[i][0],
        //   weight: 3,
        //   price: this.state.selectedFileData[i][2],
        //   days: this.state.selectedFileData[i][5]
        // },
        // {
        //   country: this.state.selectedFileData[i][0],
        //   weight: 10,
        //   price: this.state.selectedFileData[i][3],
        //   days: this.state.selectedFileData[i][5]
        // },
        // {
        //   country: this.state.selectedFileData[i][0],
        //   weight: 20,
        //   price: this.state.selectedFileData[i][4],
        //   days: this.state.selectedFileData[i][5]
        // }
      );
      // onAddNewEmsPrices(importArr[0]);
    }
    console.log(importArr, "importArr");
    onAddTransferMoscow(importArr);
  };

  handleExcelImportChange = (e, values) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    let countries = [];
    reader.onload = (event) => {
      //parse data
      const bstr = event.target.result;

      const workBook = XLSX.read(bstr, { type: "binary" });

      //get first sheet
      const workSheetName = workBook.SheetNames[0];
      const workSheet = workBook.Sheets[workSheetName];

      // countries.push(workSheet['B1'].v);
      // countries.push(workSheet['C1'].v);
      // countries.push(workSheet['D1'].v);
      // countries.push(workSheet['E1'].v);
      // countries.push(workSheet['F1'].v);
      // countries.push(workSheet['G1'].v);
      // countries.push(workSheet['H1'].v);
      // countries.push(workSheet['I1'].v);
      // countries.push(workSheet['J1'].v);
      // countries.push(workSheet['K1'].v);
      // countries.push(workSheet['L1'].v);
      // countries.push(workSheet['M1'].v);
      // countries.push(workSheet['N1'].v);
      const fileData = XLSX.utils.sheet_to_json(workSheet, {
        header: 1,
        raw: false,
      });
      // fileData.splice(0, 1);
      this.setState({
        selectedFileData: fileData,
        sheetName: workSheetName,
        countries: countries,
      });
    };
    reader.readAsBinaryString(file);
  };

  handleFilterDataSubmit = (e, values) => {
    const { transfers_moscow } = this.props;
    let my_filtered_transfer_msc = [];
    transfers_moscow.map((transfer) => {
      if (values && transfer.invoiceNo === values.invoice) {
        my_filtered_transfer_msc.push(transfer);
      }
    });
    this.setState({ my_filtered_transfer_msc });
  };

  handleFormReset = () => {
    this.setState({
      my_filtered_transfer_msc: [],
    });
  };

  hiddenRowKeys = () => {
    let hiddenArr = [];
    this.props.filtered_transfers_moscow.map((transfer, index) => {
      if (transfer.quantityLeft === 0 && this.state.displayHidden === false) {
        hiddenArr.push(transfer._id);
      }
    });
    return hiddenArr;
  };

  getTotalSum = () => {
    return this.state.selectedData.reduce(
      (acc, item) => {
        acc.totalQuantity += item.quantity || 0;
        acc.totalQuantityLeft += item.quantityLeft || 0;
        return acc;
      },
      { totalQuantity: 0, totalQuantityLeft: 0 }
    );
  };

  copyToClipboard = () => {
    const { selectedData } = this.state;

    if (selectedData.length === 0) {
      showToast("error", "No data selected to copy!");
      return;
    }

    // Format data for clipboard
    const textToCopy = selectedData
      .map((item) => `${item.productName}   ${item.invoiceNo}   ${item.boxNo}`)
      .join("\n");

    // Create a temporary textarea element
    const textarea = document.createElement("textarea");
    textarea.value = textToCopy;
    textarea.style.position = "fixed"; // Prevent scrolling issues
    textarea.style.opacity = 0; // Hide element
    document.body.appendChild(textarea);
    textarea.select();

    try {
      if (document.execCommand("copy")) {
        showToast("Copied to clipboard"); // ✅ Success message
      } else {
        showToast("Failed to copy data.");
      }
    } catch (err) {
      showToast("Failed to copy data.");
    }

    document.body.removeChild(textarea); // Cleanup
  };

  render() {
    const { SearchBar } = Search;
    const {
      transfers_moscow,
      transfers_moscow_nom,
      transfers_moscow_ser,
      transfers_moscow_inv,
      profileData,
      loading,
    } = this.props;
    const {
      selectedRows,
      my_filtered_transfer_msc,
      filtered_transfers_moscow,
    } = this.state;
    console.log(this.props);

    const { totalQuantity, totalQuantityLeft } = this.getTotalSum();

    const pageOptions = {
      sizePerPage:
        filtered_transfers_moscow.length !== 0
          ? filtered_transfers_moscow.length
          : 0,
      sizePerPageList: [500, 1000, 1500],
      totalSize:
        filtered_transfers_moscow.length !== 0
          ? filtered_transfers_moscow.length
          : 0,
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "date", // if dataField is not match to any column you defined, it will be ignored.
        order: "asc", // desc or asc
      },
    ];

    const selectRow = {
      mode: "checkbox",
      selected: this.state.selectedRows,

      onSelectAll: (isSelect, rows) => {
        if (!isSelect) {
          this.setState({ selectedRows: [], selectedData: [] });
        } else {
          const selectedRows = [];
          const selectedData = [];

          rows.forEach((row) => {
            if (row.quantityLeft !== 0) {
              selectedRows.push(row._id);
              selectedData.push({
                id: row._id,
                productName: row.productName, // ✅ Include nomenclature
                invoiceNo: row.invoiceNo, // ✅ Include orderNumber
                boxNo: row.boxNo,
                quantity: row.quantity,
                quantityLeft: row.quantityLeft,
              });
            }
          });

          this.setState({ selectedRows, selectedData });
        }
      },

      onSelect: (row, isSelect) => {
        if (!isSelect) {
          this.setState((prevState) => ({
            selectedRows: prevState.selectedRows.filter((id) => id !== row._id),
            selectedData: prevState.selectedData.filter(
              (item) => item.id !== row._id
            ),
          }));
        } else {
          if (row.quantityLeft !== 0) {
            this.setState((prevState) => ({
              selectedRows: [...prevState.selectedRows, row._id],
              selectedData: [
                ...prevState.selectedData,
                {
                  id: row._id,
                  productName: row.productName, // ✅ Include nomenclature
                  invoiceNo: row.invoiceNo, // ✅ Include orderNumber
                  boxNo: row.boxNo,
                  quantity: row.quantity,
                  quantityLeft: row.quantityLeft,
                },
              ],
            }));
          }
        }
      },
    };

    // const transfers_moscow_inv = transfers_moscow.filter((v, i, a) => a.findIndex((v2) => v2.invoiceNo === v.invoiceNo) === i);

    return (
      <React.Fragment>
        {/* {profileData.length === 0 && loading && <PageLoader />} */}
        {profileData.length !== 0 && (
          <PageLoader
            progress={!loading && { step: "Completed", time: 100 }}
            isLoading={loading}
          />
        )}
        <div className="page-content">
          <MetaTags>
            <title>Inventory #7 Russia, MOSCOW, Safekeeping</title>
          </MetaTags>
          <Container fluid>
            {profileData.permissions.includes('inventoryAccess') ? (
              <>
                {/* Render Breadcrumbs */}
                <Breadcrumbs
                  title="Korupharma"
                  breadcrumbItem="Inventory #7 Russia, MOSCOW, Safekeeping"
                />
                <Row id="card-section" onLoad={this.getScreenHeight()}>
                  <Col lg="12">
                    <Card>
                      <CardBody className="cardBodySticky">
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField="_id"
                          columns={this.state.TransferMoscowListColumns}
                          // data={my_filtered_transfer_msc.length !== 0 ? my_filtered_transfer_msc : transfers_moscow}

                          data={filtered_transfers_moscow}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField="_id"
                              columns={this.state.TransferMoscowListColumns}
                              // data={my_filtered_transfer_msc.length !== 0 ? my_filtered_transfer_msc : transfers_moscow}
                              data={filtered_transfers_moscow}
                              // search
                            >
                              {(toolkitprops) => (
                                <React.Fragment>
                                  <Row className="mb-2 searchBar">
                                    <Col md={2} sm="12">
                                      <div className="search-box ps-3 pt-1 d-flex">
                                        <div className="position-relative">
                                          <SearchBar
                                            {...toolkitprops.searchProps}
                                          />
                                          <i className="bx bx-search-alt search-icon" />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col md={2}>
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "10px",
                                          alignItems: "center",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        <Button
                                          color="info"
                                          className="btn btn-info mb-2 me-2"
                                          onClick={() => {
                                            const link =
                                              document.createElement("a");
                                            link.href =
                                              "/templates/inventory_template.xlsx"; // или .xlsx
                                            link.download =
                                              "inventory_template.xlsx";
                                            link.click();
                                          }}
                                        >
                                          <Download />
                                        </Button>
                                        <AvForm
                                          className="d-flex"
                                          id="filter-date-form"
                                          onValidSubmit={
                                            this.handleExcelImportSubmit
                                          }
                                        >
                                          <FormGroup className="me-2">
                                            <Label
                                              for="file-upload"
                                              className="custom-file-upload"
                                            >
                                              <i className="mdi mdi-file-import-outline label-icon"></i>
                                              Import CSV data
                                            </Label>
                                            <AvField
                                              type="file"
                                              name="excel"
                                              id="file-upload"
                                              onChange={
                                                this.handleExcelImportChange
                                              }
                                            />
                                          </FormGroup>
                                          <FormGroup className="me-2">
                                            <button className="btn btn-success save-user">
                                              Import
                                            </button>
                                          </FormGroup>
                                        </AvForm>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "10px",
                                          alignItems: "center",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        <MultiSelect
                                          id="nomenclatureCode"
                                          label="Select Nomenclature"
                                          values={transfers_moscow_nom}
                                          onSelectChange={
                                            this.handleSelectChange
                                          }
                                          selectedValues={
                                            this.state.selectedValues
                                              .nomenclatureCode
                                          }
                                        />
                                        <MultiSelect
                                          id="invoiceNo"
                                          label="Select Invoice"
                                          values={transfers_moscow_inv}
                                          onSelectChange={
                                            this.handleSelectChange
                                          }
                                          selectedValues={
                                            this.state.selectedValues.invoiceNo
                                          }
                                        />
                                        <MultiSelect
                                          id="serialNo"
                                          label="Select Serial"
                                          values={transfers_moscow_ser}
                                          onSelectChange={
                                            this.handleSelectChange
                                          }
                                          selectedValues={
                                            this.state.selectedValues.serialNo
                                          }
                                        />
                                        <Button
                                          color="success"
                                          className="font-16 btn-block btn btn-success btn-lg"
                                          onClick={this.handleButtonClick}
                                        >
                                          Search
                                        </Button>
                                        <Button
                                          color="danger"
                                          className="btn btn-danger"
                                          onClick={this.resetSelections}
                                        >
                                          Reset
                                        </Button>
                                      </div>
                                    </Col>

                                    <Col md={2} sm="12">
                                      <div className="text-sm-end pe-3">
                                        <Button
                                          color="success"
                                          className="font-16 btn-block btn btn-success btn-lg"
                                          onClick={this.toggleHiddenOrders}
                                          id="create-order-btn"
                                        >
                                          {this.state.displayHidden ? (
                                            <>
                                              <i className="mdi mdi-file me-1" />
                                              Hide Empty Products
                                            </>
                                          ) : (
                                            <>
                                              <i className="mdi mdi-file-hidden me-1" />
                                              Show All Products
                                            </>
                                          )}
                                        </Button>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="table-section">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerClasses="header-class is-sticky-hdr"
                                      id="tableScroll"
                                      filter={filterFactory()}
                                      selectRow={selectRow}
                                      noDataIndication="Filtered Data is not selected"
                                      rowClasses={this.rowClasses}
                                      hiddenRows={this.hiddenRowKeys()}
                                      responsive
                                      cellEdit={cellEditFactory({
                                        mode: "click",
                                        blurToSave: true,
                                        afterSaveCell: this.afterSaveCell,
                                      })}
                                    />
                                    <div
                                      className={
                                        selectedRows.length === 0
                                          ? "action_row hidden"
                                          : "action_row transfer_priority"
                                      }
                                    >
                                      <AvForm
                                        onValidSubmit={
                                          this.handleGlobalActionSubmit
                                        }
                                      >
                                        <AvField
                                          type="select"
                                          name="action"
                                          className="form-select"
                                          value={this.state.action || ""}
                                        >
                                          <option value="SELECT ACTION">
                                            SELECT ACTION
                                          </option>
                                          <option value="write_off">
                                            WRITE-OFF
                                          </option>
                                          <option value="delete">DELETE</option>
                                        </AvField>
                                        <button className="btn btn-success save-user">
                                          {" "}
                                          APPLY{" "}
                                        </button>
                                        <div className="d-flex ms-5 make-text-bold font-size-22">
                                          <span className="ps-2">
                                            <Package /> {totalQuantity}
                                          </span>
                                          <span className="ps-2">
                                            <PackageOpen /> {totalQuantityLeft}
                                          </span>
                                        </div>
                                        <Button
                                          color="success"
                                          className="font-16 btn-block btn btn-success btn-lg"
                                          onClick={this.copyToClipboard}
                                        >
                                          Copy
                                        </Button>
                                      </AvForm>
                                      {/* <div style={{ marginTop: '20px', fontWeight: 'bold' }}>
                                        Total Quantity: {totalQuantity} | Total Quantity Left: {totalQuantityLeft}
                                      </div> */}
                                    </div>
                                  </Row>
                                  {this.state.alert}
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : (
              <Alert color="danger">
                {" "}
                You do not have access to this page.{" "}
              </Alert>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

TransferMoscowList.propTypes = {
  transfers_moscow: PropTypes.array,
  transfers_moscow_nom: PropTypes.array,
  transfers_moscow_inv: PropTypes.array,
  transfers_moscow_ser: PropTypes.array,
  filtered_transfers_moscow: PropTypes.array,
  // onGetTransferMoscow: PropTypes.func,
  onGetTransferMoscowList: PropTypes.func,
  onGetFilteredTransfersMoscow: PropTypes.func,
  onAddTransferMoscow: PropTypes.func,
  onUpdateTransferMoscow: PropTypes.func,
  onDeleteTransferMoscow: PropTypes.func,
};

const mapStateToProps = ({ transfers }) => ({
  transfers_moscow: transfers.transfers_moscow,
  transfers_moscow_nom: transfers.transfers_moscow_nom,
  transfers_moscow_inv: transfers.transfers_moscow_inv,
  transfers_moscow_ser: transfers.transfers_moscow_ser,
  filtered_transfers_moscow: transfers.filtered_transfers_moscow,
  loading: transfers.loading,
});

const mapDispatchToProps = (dispatch) => ({
  // onGetTransferMoscow: () => dispatch(getTransfersMoscow()),
  onGetTransferMoscowList: () => dispatch(getTransfersMoscowList()),
  onAddTransferMoscow: (transfers) => dispatch(addTransferMoscow(transfers)),
  onGetFilteredTransfersMoscow: (transfers) =>
    dispatch(getFilteredTransfersMoscow(transfers)),
  onUpdateTransferMoscow: (transfers) =>
    dispatch(updateTransferMoscow(transfers)),
  onDeleteTransferMoscow: (transfers) =>
    dispatch(deleteTransferMoscow(transfers)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TransferMoscowList));
